import type { SwiperOptions } from "swiper/types";

export const swiperOptions: SwiperOptions = {
    // slidesPerView: 1.07,
    spaceBetween: 41,

    breakpoints: {
        319: {
            spaceBetween: 41,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
        },
        464: {
            slidesOffsetAfter: 40,
            slidesOffsetBefore: 40,
        },
        984: {
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
        },
        1440: {
            slidesOffsetBefore: 40,
        },

        1919: {
            spaceBetween: 41,
            slidesOffsetBefore: 40,
        },
        2560: {
            spaceBetween: 56,
            slidesOffsetBefore: 52,
        },
        3840: {
            slidesOffsetBefore: 80,
            spaceBetween: 82,
        },
    },
};
